export function isArray(candidate) {
  return Array.isArray(candidate);
}
